import { useReactiveVar } from '@apollo/client';
import { useFeatureValue } from '@growthbook/growthbook-react';

import { FEATURE_TOGGLE } from '@/constants/featuretoggle';
import { activeRegionStatesVar } from '@/util/apollo/cache';
import { allowedStates } from '@/util/constants';

const useGetValidStates = () => {
  const checkRegion = useFeatureValue(FEATURE_TOGGLE.RegionFeature, false);
  const regionStates = useReactiveVar(activeRegionStatesVar);
  const validStates =
    checkRegion && regionStates ? regionStates : allowedStates;
  return validStates;
};

export default useGetValidStates;
